@if (fetchState !== FETCH_STATUS.NEW) {
  @switch (articleUsageState) {
    @case (0) {
      <span class="label label-warning"
        title="dies ist der erste Abruf für diesen Artikel"
        >
        Neu
      </span>
    }
    @case (1) {
      <span class="label label-default"
        title="der Artikel wurde bereits in einem früheren Abruf bearbeitet"
        >
        Bestand
      </span>
    }
  }
}
